interface UniversityLogo {
  src: string;
  alt: string;
}

export const universityLogos: UniversityLogo[] = [
  { src: 'https://cdn.cognora.ca/student/university-logos/stanford_logo.png', alt: 'Stanford' },
  { src: 'https://cdn.cognora.ca/student/university-logos/University%20of%20Toronto%20Logo.png', alt: 'UofT' },
  { src: 'https://cdn.cognora.ca/student/university-logos/UofGuelph.png', alt: 'UofGuelph' },
  { src: 'https://cdn.cognora.ca/student/university-logos/York%20University%20Logo.png', alt: 'York University' },
  { src: 'https://cdn.cognora.ca/student/university-logos/University%20of%20Manitoba%20Logo.jpg', alt: 'University of Manitoba' },
  { src: 'https://cdn.cognora.ca/student/university-logos/BuffaloState.png', alt: 'Buffalo State' },
  { src: 'https://cdn.cognora.ca/student/university-logos/ubc-logo.png', alt: 'University of British Columbia' },
  { src: 'https://cdn.cognora.ca/student/university-logos/university-of-waterloo-1.svg', alt: 'University of Waterloo' },
  { src: 'https://cdn.cognora.ca/student/university-logos/UniversityofPennsylvania.png', alt: 'University of Pennsylvania' },
  { src: 'https://cdn.cognora.ca/student/university-logos/dalhousie_university.jpg', alt: 'Dalhousie University' },
];